import { validateEmail } from "web-apps/company/utils/utils";

export interface StampClockCredentials {
  readonly email: string;
  readonly password: string;
}

const MINIMUM_PASSWORD_LENGTH = 6;

export function isStampClockEmailValid(email: string): boolean {
  return validateEmail(email.trim());
}

export function isStampClockPasswordValid(password: string): boolean {
  return password.length >= MINIMUM_PASSWORD_LENGTH;
}

export function normalizeStampClockCredentials(
  credentials: StampClockCredentials,
): StampClockCredentials {
  return { email: credentials.email.trim(), password: credentials.password };
}
